<template>
  <picture v-if="load">
    <source :srcset="smallImage" media="(max-width: 697px)"/>
    <img class="image" :src="image" :alt="alt">
  </picture>
</template>

<script>
  export default {
    name: 'PictureLoader',

    props: [
      'src', // Image source
      'lazy', // Flag to indicate if the image should be loading lazily
      'alt'
    ],

    components: {},

    /**
     * Once component is mounted, if the image is set to be lazy-loaded, then a new event listener will be registered,
     * listening for the load event on the window. If the document is already ready, then this won't be registered
     *
     * If the image isn't set for lazy loading, then it will simply be loaded right away
     */
    mounted: function () {
      if (this.lazy === 'true' && document.readyState !== 'complete') {
        window.addEventListener('load', () => {
          this.load = true
        })
      } else {
        this.load = true
      }
    },

    computed: {
      image () {
        return this.src
      },
      smallImage () {
        return this.src.replace(/(\.(png|jpg|gif|jpeg))$/, '_small$1')
      }
    },

    data: function () {
      return {
        load: false
      }
    },

    methods: {}
  }
</script>



// WEBPACK FOOTER //
// PictureLoader.vue?c1e39914